<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                {{ $t('labels.sickLeave') }}
            </v-card-title>
            <v-card-text>
                <v-row dense wrap>
                    <v-col cols="12">
                        <DatePicker
                            v-model="statisticsModal.dateFrom"
                            :date-label="'* ' + $t('fields.from')"
                        ></DatePicker>
                    </v-col>
                    <v-col cols="12">
                        <DatePicker v-model="statisticsModal.dateTo" :date-label="'* ' + $t('fields.to')"></DatePicker>
                    </v-col>
                    <v-col cols="4">
                        <v-btn class="mr-2" :disabled="!canExport" color="primary" @click="exportClick(false)">
                            <v-icon small>fa-file-excel</v-icon>&nbsp;{{ $t('buttons.export') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import DatePicker from '@/components/trinkets/DatePicker';

export default {
    name: 'SickLeaveStatistics',
    components: {DatePicker},
    data: function () {
        return {
            statisticsModal: {
                entities: [],
                maritimeObjects: [],
                dateFrom: null,
                dateTo: null,
            },
            maritimeObjectForEntitites: [],
            componentKey: 1,
            canExport: false,
        };
    },
	methods: {
		exportClick() {
			let dataForSelect = this.statisticsModal;
			this.$APICall('post', 'excel/seafarer-sick-leave-statistics', dataForSelect, (data) => {
				window.open(data.link);
			});
		},

	},
    watch: {

        'statisticsModal': {
            handler: function () {
                let success = true;
                if (

                    this.statisticsModal.dateFrom == null ||
                    this.statisticsModal.dateTo == null ||
                    this.statisticsModal.dateFrom > this.statisticsModal.dateTo
                ) {
                    success = false;
                }
                this.canExport = success;
            },
            deep: true,
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
    },
};
</script>

<style scoped></style>
